/* eslint-disable react/display-name */
import React, { useState, forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { has, find, isEmpty } from 'lodash';
import { Card, Row, Col, Form, Image, Accordion } from "react-bootstrap";

const right_access_dropdown = [
  {
    value: 'disabled',
    label: 'Disabled',
  },
  {
    value: 'self',
    label: 'Self',
  },
  {
    value: 'all',
    label: 'All',
  },
];

const Page2 = props => {
  const {
    title,
    depth,
    objIndex,
    children,
    className,
    open: openProp,
    label: Label,
    objectType,
    formState,
    setFormState,
    objectListItem,
    setObjectId,
    ...rest
  } = props;

  const uniqueKey = `${objIndex}-${depth}`; 

  const objectsState = useSelector(state => state.objectsState);
  const session = useSelector(state => state.session);

  const [activeKey, setActiveKey] = useState(null);

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const handleChange = (event, id, accessType, parent_id, current = true) => {
    //setiing permission for current object
    setObjectPermission(event, id, accessType, current);

    //setting permission for parent
    let objectsList = objectsState.objectsList;
    if (!isEmpty(parent_id) && accessType === 'view' && (event.target.checked || event.target.value != 'disabled')) {
      let item = find(objectsList, { 'id': parent_id });  
      handleChange(event, item.id, accessType, item.parent_id, false)
    }

    //setting view button on edit/add/delete
    /*if (["add", "edit", "delete", "view_deleted"].includes(accessType) && event.target.checked) {
      handleChange(event, id, 'view', parent_id, false);
    }

    //setting view button on edit/add/delete
    if (["reporting_access_edit", "reporting_access_delete", "reporting_access_view"].includes(accessType) && event.target.value != 'disabled') {
      handleChange(event, id, 'view', parent_id, false); 
    }*/

    if (accessType === "reporting_access_view" ) {
      if(event.target.value != 'disabled'){
        handleChange(event, id, 'view', parent_id, false); 
      }
      else{
        setFormState(formState => ({
          ...formState,
          values: {
            ...formState.values,
            role_access_rights: {
              ...formState.values.role_access_rights,
              [id]: {
                ...formState.values.role_access_rights[id],
                ['view']: false,
              }
            }
          }
        }));
      }
    }

  };

  const setObjectPermission = (event, id, accessType, current) => {
    let a_type = (event.target.type === 'checkbox') ? !(formState.values.role_access_rights[id][accessType]) : event.target.value
    //let a_type = event.target.value; //!(formState.values.role_access_rights[id][accessType]);
    if (!current)
      a_type = true;

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        role_access_rights: {
          ...formState.values.role_access_rights,
          [id]: {
            ...formState.values.role_access_rights[id],
            [accessType]: a_type,
          }
        }
      }
    }));
  };

  let marginLeft = 0;
  if (depth > 0) {
    marginLeft = 20 * depth;
  }

  const style = {
    marginLeft
  };


  /*if (children) {
    return (
      <ListItem
        {...rest}
        className={clsx(classes.item, className)}
        disableGutters
      >
        <Box
          className={classes.box}
          style={style}
        >
          <Grid container spacing={3}>
            <Grid item sm={2}>
              {title}
            </Grid>
            <Grid item sm={1}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['add'] : false}
                    onChange={(event) => { handleChange(event, objectListItem.id, 'add', objectListItem.parent_id) }}
                    color="primary"
                    className={classes.rightsCheckbox}
                  />
                }
                label="Add"
                classes={{
                  label: classes.rightsLabel
                }}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                helperText="Please select edit access"
                className={classes.rigthsDropdown}
                select
                value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_edit'] : 'disabled'}
                onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_edit', objectListItem.parent_id) }}
              >
                {right_access_dropdown.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem> 
                ))}
              </TextField>
            </Grid>
            <Grid item sm={2}>
              <TextField
                helperText="Please select delete access"
                className={classes.rigthsDropdown}
                select
                value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_delete'] : 'disabled'}
                onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_delete', objectListItem.parent_id) }}
              >
                {right_access_dropdown.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem> 
                ))}
              </TextField>
            </Grid>
            <Grid item sm={2}>
              <TextField
                helperText="Please select view access"
                className={classes.rigthsDropdown}
                select
                value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_view'] : 'disabled'}
                onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_view', objectListItem.parent_id) }}
              >
                {right_access_dropdown.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem> 
                ))}
              </TextField>
            </Grid>
            <Grid item sm={3}>
              {(session.user.is_super_admin === 'y')?
              
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['view_deleted'] : false}
                      onChange={(event) => { handleChange(event, objectListItem.id, 'view_deleted', objectListItem.parent_id) }}
                      color="primary"
                      className={classes.rightsCheckbox}
                    />
                  }
                  label="View Deleted"
                  classes={{
                    label: classes.rightsLabel
                  }}
                />
              :''}
            
            
              {open ? (
                <RemoveIcon
                  className={classes.expandIcon}
                  color="inherit"
                  onClick={handleToggle}
                />
              ) : (
                <AddIcon
                  className={classes.expandIcon}
                  color="inherit"
                  onClick={handleToggle}
                />
              )}
            </Grid>
          </Grid>
        </Box>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  } else {
    return (
      <ListItem
        {...rest}
        className={clsx(classes.itemLeaf, className)}
        disableGutters
      >
        <Box
          className={clsx(classes.boxLeaf, `depth-${depth}`)}
          style={style}
        >
          <Grid container spacing={3}>
            <Grid item sm={2}>
              {title}
            </Grid>
            <Grid item sm={1}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['add'] : false}
                    onChange={(event) => { handleChange(event, objectListItem.id, 'add', objectListItem.parent_id) }}
                    color="primary"
                    className={classes.rightsCheckbox}
                  />
                }
                label="Add"
                classes={{
                  label: classes.rightsLabel
                }}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                helperText="Please select edit access"
                className={classes.rigthsDropdown}
                select
                value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_edit'] : 'disabled'}
                onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_edit', objectListItem.parent_id) }}
              >
                {right_access_dropdown.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem> 
                ))}
              </TextField>
            </Grid>
            <Grid item sm={2}>
              <TextField
                helperText="Please select delete access"
                className={classes.rigthsDropdown}
                select
                value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_delete'] : 'disabled'}
                onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_delete', objectListItem.parent_id) }}
              >
                {right_access_dropdown.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem> 
                ))}
              </TextField>
            </Grid>
            <Grid item sm={2}>
              <TextField
                helperText="Please select view access"
                className={classes.rigthsDropdown}
                select
                value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_view'] : 'disabled'}
                onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_view', objectListItem.parent_id) }}
              >
                {right_access_dropdown.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem> 
                ))}
              </TextField>
              {/*<FormControlLabel
                control={
                  <Checkbox
                    checked={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['view'] : false}
                    onChange={(event) => { handleChange(event, objectListItem.id, 'view', objectListItem.parent_id) }}
                    color="primary"
                    className={classes.rightsCheckbox}
                  />
                }
                label="View"
                classes={{
                  label: classes.rightsLabel
                }}
              />*}
            </Grid>
            <Grid item sm={3}>
              {(session.user.is_super_admin === 'y')?
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['view_deleted'] : false}
                      onChange={(event) => { handleChange(event, objectListItem.id, 'view_deleted', objectListItem.parent_id) }}
                      color="primary"
                      className={classes.rightsCheckbox}
                    />
                  }
                  label="View Deleted"
                  classes={{
                    label: classes.rightsLabel
                  }}
                />
              :''}
            </Grid>
          </Grid>
        </Box>
      </ListItem>
    );
  }*/

   

    if (children) {
      return (
        <Card.Body className="font-13 font-weight-medium">
          <Row className="py-2 align-items-center">
            <Col>
              <h6 className="font-13 font-weight-medium page-heading">{title} </h6>
            </Col>
            <Col>
              <Form>
                <div key={`default-checkbox`} className="d-flex align-items-center">
                  <Form.Check 
                    type={'checkbox'}
                    id={`default-checkbox`}
                    className="check-box-add"
                    checked={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['add'] : false}
                    onChange={(event) => { handleChange(event, objectListItem.id, 'add', objectListItem.parent_id) }}
                  />{" "}
                  <span className="ms-2 page-heading">Add</span>
                </div>
              </Form>
            </Col>
            <Col>
              <div className="edit-role">
                <label className="font-11 font-weight-normal page-heading">
                  Edit Access
                </label>
                <Form.Select 
                  aria-label="Default select example"
                  value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_edit'] : 'disabled'}
                  onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_edit', objectListItem.parent_id) }}
                  className='access-input'
                >
                  {right_access_dropdown.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option> 
                  ))}
                </Form.Select>
              </div>
            </Col>
            <Col>
              <div className="edit-role">
                <label className="font-11 font-weight-normal page-heading">
                  Delete Access
                </label>
                <Form.Select 
                  aria-label="Default select example"
                  value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_delete'] : 'disabled'}
                  onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_delete', objectListItem.parent_id) }}
                  className='access-input'
                >
                  {right_access_dropdown.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option> 
                  ))}
                </Form.Select>
              </div>
            </Col>
            <Col>
              <div className="edit-role">
                <label className="font-11 font-weight-normal page-heading">
                  View Access
                </label>
                <Form.Select 
                  aria-label="Default select example"
                  value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_view'] : 'disabled'}
                  onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_view', objectListItem.parent_id) }}
                  className='access-input'
                >
                  {right_access_dropdown.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option> 
                  ))}
                </Form.Select>
              </div>
            </Col>
            <Col lg={2} className="text-end">
              <span onClick={() => toggleAccordion(uniqueKey)} className="cursor-pointer">
                {activeKey === uniqueKey ? (
                  <Image src="/assets/images/accordian-img2.svg" />
                ) : (
                  <Image src="/assets/images/accordian-img.svg" />
                )}
              </span>
            </Col>
          </Row>
          <hr className="m-0 role-AI-hr" />
        
        <Accordion activeKey={activeKey}>
          <Accordion.Collapse eventKey={uniqueKey}>
            <div>{children}</div>
          </Accordion.Collapse>
        </Accordion>
      
        </Card.Body>
      );
    } else {
      return (
        <Card.Body className="font-13 font-weight-medium">
          <Row className="py-2 align-items-center">
            <Col>
              <h6 className="font-13 font-weight-medium page-heading">{title} </h6>
            </Col>
          

            <Col>
              <Form>
                <div key={`default-checkbox`} className="d-flex align-items-center">
                  <Form.Check // prettier-ignore
                    type={'checkbox'}
                    id={`default-checkbox`}
                    className="check-box-add"
                    checked={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['add'] : false}
                    onChange={(event) => { handleChange(event, objectListItem.id, 'add', objectListItem.parent_id) }}
                  />{" "}
                  <span className="ms-2 page-heading">Add</span>
                </div>
              </Form>
            </Col>

            <Col>
              <div className="edit-role">
                <label className="font-11 font-weight-normal page-heading">
                  View Access
                </label>
                <Form.Select 
                  aria-label="Default select example"
                  value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_view'] : 'disabled'}
                  onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_view', objectListItem.parent_id) }}
                  className='access-input'
                >
                  {right_access_dropdown.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option> 
                  ))}
                </Form.Select>
              </div>
            </Col>
            <Col>
              <div className="edit-role">
                <label className="font-11 font-weight-normal page-heading">
                  Edit Access
                </label>
                <Form.Select 
                  aria-label="Default select example"
                  value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_edit'] : 'disabled'}
                  onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_edit', objectListItem.parent_id) }}
                  className='access-input'
                >
                  {right_access_dropdown.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option> 
                  ))}
                </Form.Select>
              </div>
            </Col>
            <Col>
              <div className="edit-role">
                <label className="font-11 font-weight-normal page-heading">
                  Delete Access
                </label>
                <Form.Select 
                  aria-label="Default select example"
                  value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_delete'] : 'disabled'}
                  onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_delete', objectListItem.parent_id) }}
                  className='access-input'
                >
                  {right_access_dropdown.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option> 
                  ))}
                </Form.Select>
              </div>
            </Col>
            {/* <Col>
              <div className="edit-role">
                <label className="font-11 font-weight-normal">
                  View Access
                </label>
                <Form.Select 
                  aria-label="Default select example"
                  value={has(formState.values.role_access_rights, objectListItem.id) ? formState.values.role_access_rights[objectListItem.id]['reporting_access_view'] : 'disabled'}
                  onChange={(event) => { handleChange(event, objectListItem.id, 'reporting_access_view', objectListItem.parent_id) }}
                >
                  {right_access_dropdown.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option> 
                  ))}
                </Form.Select>
              </div>
            </Col> */}
         
          </Row>
          <hr className="m-0 role-AI-hr" />
        </Card.Body>
      );
    }

};

Page2.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  label: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  objectType: PropTypes.string.isRequired
};

export default Page2;
